// Markets — catalog management. Categories → Topics → Rules.
// Sub-page nav lives in the operator sidebar, no top tabs — the tabs
// duplicated the sidebar group and added a layout shift on every
// navigation between the three list pages.
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/markets")({
  component: MarketsLayout,
});

function MarketsLayout() {
  return <Outlet />;
}
